import React, { useEffect, useMemo, useState } from 'react';
import ReactSelect from 'react-select';
import axiosPrivate from '../../../hooks/axiosPrivate';
import DataTable2 from '../../../context/components/DataTable2';
import { showErrorToast, showSuccessToast } from '../../../Toster';

const searchItems = ['name', 'roles', 'email', 'mobile'];

const headers = [
  { name: 'DEALER NAME', field: 'name', sortable: true, classKey: 'w250' },
  { name: 'Circular', field: 'circular', sortable: true, classKey: '' },
];

export default function AssignDealer({ circulars = [] }) {
  const [selectedCircular, setSelectedCircular] = useState(null);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [dealers, setDealers] = useState([]);

  const circularOptions = useMemo(() => {
    return circulars.map((circular) => ({
      value: circular.id,
      label: circular.name,
    }));
  }, [circulars]);

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#767676' : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: state.isSelected ? '#767676' : '#e0e0e0',
      },
    }),
    control: (base) => ({
      ...base,
      borderColor: '#ddd',
      boxShadow: 'none',
      '&:hover': { boxShadow: '0px 0px 2px 2px #d6d4dd' },
    }),
  };

  const fetchDealers = ()=>{
    axiosPrivate.post('dealers').then((dealers) => {
      setDealers(dealers?.data?.data || []);
    });
  }

  useEffect(() => {
    fetchDealers()
   
  }, []);

  const dealerOptions = useMemo(() => {
    return dealers.map((dealer) => ({
      value: dealer.id,
      label: dealer.name,
    }));
  }, [dealers]);

  const handleSubmit = async () => {
    const selectedDealerIds = selectedDealer.map((dealer) => dealer.value);
    const data = {
      dealerList: selectedDealerIds,
      circularId: selectedCircular.value,
    };
    try {
      const response = await axiosPrivate.post(
        'circular/assign-circular-dealer',
        data
      );
      if(response?.data?.status) {
          showSuccessToast(response?.data?.message || 'Dealer assigned successfully');
          setSelectedCircular(null);
          setSelectedDealer(null)
          fetchDealers()
      }else{
        showErrorToast(response?.data?.message);
      }
      console.log('response', response);
    } catch (error) {
      showErrorToast(error?.response?.data?.message || error?.message); 
      console.error('Error assigning circular to dealer:', error);
    }
  }

  return (
    <>
      {/* hearder breadcrumb */}
      <div className='card-header'>
        <strong className=''>Assign circular to dealer</strong>
      </div>
      <div className='card'>
        <div className='row dealer-box'>
          <div
            className=''
            style={{
              display: 'flex',
              gap: '10px',
              justifyContent: 'space-between',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <div className='' style={{ width: '50%' }}>
              <label>
                Circulars :<span className='required'>*</span>
              </label>
              <ReactSelect
                id='dealer_id'
                styles={customStyles}
                name='dealer_id'
                options={circularOptions}
                value={selectedCircular}
                onChange={(selectedOption) => {
                  setSelectedCircular(selectedOption);
                }}
                placeholder='Select Circular'
                isSearchable
              />
            </div>
            <div className='' style={{ width: '50%' }}>
              <label>
                Dealers :<span className='required'>*</span>
              </label>
              <ReactSelect
                isMulti
                id='dealer_id'
                styles={customStyles}
                name='dealer_id'
                options={dealerOptions}
                value={selectedDealer}
                onChange={(selectedOption) => {
                  setSelectedDealer(selectedOption);
                }}
                placeholder='Select Circular'
                isSearchable
              />
            </div>
          </div>
          <div
            className='col-12 submit-btn my-2 '
            style={{
              display: 'flex',
              justifyContent: 'end',
              gap: '10px',
              marginTop: '20px',
            }}
          >
            <button
              disabled={!selectedCircular || !selectedDealer}
              type='submit'
              className='btn btn-primary ml-2'
              onClick={handleSubmit}
            >
              Assign Dealer
            </button>
          </div>
          <hr />
          {circularOptions && dealerOptions && (
            <div
              style={{
                marginTop: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width: '100%',
              }}
            >
              <label>Dealers List</label>
              <div className='table-responsive'>
                {
                  <DataTable2
                    lists={dealers.map((dealer) => ({
                      ...dealer,
                      circular: circularOptions.find(
                        (circular) => circular.value === dealer.circular_id
                      )?.label,
                    }))}
                    headers={headers}
                    searchItems={searchItems}
                  />
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
